var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'dot')?_c('DotLoading'):(_vm.type === 'card')?_c('LvLoadingCard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }